<template>
  <div class="section maps-section">
    <div class="controls">
      <h1>{{ title }}</h1>
      <p>{{ text }}</p>
      <input type="text" v-model="zip" placeholder="indtast dit postnummer her">

      <span class="more">
        Læs mere om kampagnen
        <icon-arrow fill="#E4003F" />
      </span>
    </div>
    <div class="map">
      <google-map :zoom="zoom" :lat="lat" :lng="lng" :disableDefaultUI="$options.disableDefaultUI">
        <google-map-cluster>
          <google-map-marker @click="goToMarker(marker)" :key="marker.objectId" :lat="marker.lat" :lng="marker.lng" v-for="marker in markers">
            <div class="map-tooltip">
              <h3 class="marker-org">{{ marker.org }}</h3>
              <funding :funding="marker.funding" />
            </div>
          </google-map-marker>
        </google-map-cluster>
      </google-map>
    </div>
  </div>
</template>

<script>
import GoogleMap from '@/components/map'
import GoogleMapCluster from '@/components/map/cluster'
import GoogleMapMarker from '@/components/map/marker'
import Geo from '@/library/geo'
import Funding from '@/components/funding'
import iconArrow from '@icons/icon-slide-arrow'

import markers from '@/data/markers'

export default {
  props: {
    title: { type: String, required: false, default: 'De små ting har stor betydning' },
    text: { type: String, required: false, default: 'Spar Nord og Spar Nord Fonden støtter hvert år lokale foreninger med over 50 millioner kroner i donationer og sponsorater' }
  },
  components: { GoogleMap, GoogleMapCluster, GoogleMapMarker, Funding, iconArrow },
  disableDefaultUI: window.innerWidth < 413,
  data: () => ({
    lat: 56.0769037,
    lng: 10.1620189,
    zip: null,
    zoom: 7
  }),
  watch: {
    zip: 'getZipLocation'
  },
  methods: {
    async getZipLocation () {
      if (this.zip.length === 4) {
        let city = await Geo.zip(this.zip)

        this.lat = city.geometry.location.lat
        this.lng = city.geometry.location.lng
        this.zoom = 12
      }
    },

    goToMarker (marker) {
      this.lat = marker.lat
      this.lng = marker.lng
      this.zoom = 14
    }
  },
  computed: {
    markers () {
      return markers
    }
  }
}
</script>

<style lang="scss" scoped>
  /* Import from Spar Nord Assets */
  @import '~@styles/global/index';
  @import '~@styles/colors/variables';
  @import '~@styles/mq/variables';
  @import '~@styles/mixins/index';
  @import '~@animations/easings/variables';
  @import '~@animations/durations/variables';

  .maps-section {

    @media #{$above-breakpoint-768} {
      min-height: 700px;
      max-height: 800px;

      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: stretch;
      justify-content: flex-start;
      flex-direction: row;
      height: 100%;
    }

    background-color: $color-grey;

    > * {
      flex: 0 0 100%;

      @media #{$above-breakpoint-1024} {
        flex: 0 0 50%;

      }
    }

    .controls {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      flex-direction: column;

      flex: 0 0 45%;

      position: relative;

      max-width: $global-width / 2.233;
      margin-left: auto;
      padding-left: $global-padding;
      padding-right: $global-padding;

      @media #{$below-breakpoint-768} {
        padding-top: $global-padding * 2;
        padding-top: $global-padding * 2;
      }

      @media #{$above-breakpoint-768} {
        padding-left: $global-padding;
        padding-right: $global-padding * 4;
      }

      h1, p {
        width: 100%;
      }

      h1 {
        @include font-size(30px, 40px);
        font-weight: 700;
        line-height: 1.2;

        margin-top: auto;
        margin-bottom: $global-padding * 2;

        @at-root .internet-explorer #{&} {
          margin-top: $global-padding * 2;
        }
      }

      p {
        font-weight: 600;
        margin-bottom: $global-padding * 2;
      }

      .more {
        display: flex;
        flex-direction: column;
        align-items: center;

        color: $color-red;
        text-align: center;

        margin-top: auto;
        margin-bottom: $global-padding;

        @at-root .internet-explorer #{&} {
          margin-top: $global-padding * 2;
        }

        @media #{$below-breakpoint-1024} {
          margin-top: $global-padding * 2;
        }
      }

      svg {
        transform: scale(0.75);
        margin-top: $global-padding / 2;
      }
    }
  }

  input {
    border: 2px solid $color-red;
    background: $color-white;
    color: $color-red;
    padding: 0 20px;
    height: $global-padding * 4;
    line-height: 1;

    display: block;
    width: 100%;

    max-width: 100%;

    @include font-size(16px, 18px);
    line-height: 1;
    font-weight: 600;

    transition: .3s $easeing-OutExpo;
    cursor: pointer;

    text-align: center;

    position: relative;
    z-index: 2;

    &:active, &:focus {
      outline: none;

      @media #{$below-breakpoint-768} {
        -webkit-text-size-adjust: 100%;
        font-size: initial;
      }
    }

    &::placeholder {
      color: $color-red;
    }

    &::-ms-clear {
      display: none;
    }
  }

  input:focus,
  input:not(:placeholder-shown) {
    box-shadow: 0 5px 10px rgba($color-red, .2);
  }

  input:hover {
    box-shadow: 0 5px 10px rgba($color-red, .2);
  }

  input:focus:placeholder-shown::placeholder {
    color: $color-grey-xx;
  }

  .map {
    flex: 0 0 55%;
  }
</style>

<style>
  a[href^="http://maps.google.com/maps"]{display:none !important}
  a[href^="https://maps.google.com/maps"]{display:none !important}

  .gmnoprint a, .gmnoprint span, .gm-style-cc {
      display:none;
  }
  .gmnoprint:not(.gm-bundled-control) .gmnoprint div {
      background:none !important;
  }
</style>



// WEBPACK FOOTER //
// src/sections/map.vue